import { useState, useEffect } from "react";

export function useDetectIOS() {
  const [isIOSDevice, setIsIOSDevice] = useState(false);

  useEffect(() => {
    if (typeof navigator === "undefined") return;

    const checkIOS = () =>
      /iPad|iPhone|iPod/.test(navigator.userAgent) ||
      (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1) ||
      (/Apple/.test(navigator.vendor) && "ontouchend" in document);

    setIsIOSDevice(checkIOS());
  }, []);
// alert(isIOSDevice)
  return isIOSDevice;
}